<script>
    /*
    	FiltersMenuCheckbox.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

	export let source;
	export let prop;
	export let setValue;
	export let label;

	$: value = source[prop];
	$: isSelected = value === true;				// always checks for true

    onMount(() => {
    })

	const _onClick = () => {
		value = !value;
		setValue(source, prop, value);
	}


</script>

<style>

    /* borrowed from BOOLEAN CHECKBOX - custom CSS graphics */
    .filter-checkbox {
        width: 100%;
        margin-bottom: 2px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .filter-checkbox .label {
        width: 170px;
        margin-left: 10px;
        font-size: 14px;
        color: var(--tcui-dark-purple);
    }

    .filter-checkbox .outer {
        width: 14px;
        height: 14px;
        border-radius: 25%;
        border: 1px solid #DFCDD8;
    }

    .filter-checkbox .outer.selected {
        border: 1px solid var(--tcui-secondary);
        background-color: var(--tcui-secondary);
    }

    .filter-checkbox .inner {
        position: relative;
        left: 0px;
        top: -1px;
        width: 3px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="filter-checkbox" on:click={_onClick}>
    {#if isSelected}
        <div class="outer flex-center selected">
            <div class="inner"></div>
        </div>
    {:else}
        <div class="outer flex-center"></div>
    {/if}
    <div class="label ellipsis">{label}</div>
</div>    
